/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PTTWakeUpRequest, UpdateAccountRequest, UpdatePushNotificationRequest } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Accounts<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name AccountsDelete
   * @request DELETE:/accounts/{accountId}
   */
  accountsDelete = (accountId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/accounts/${accountId}`,
      method: "DELETE",
      ...params,
    });
  /**
   * No description
   *
   * @name AccountsPartialUpdate
   * @request PATCH:/accounts/{accountId}
   */
  accountsPartialUpdate = (accountId: string, data: UpdateAccountRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/accounts/${accountId}`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name DevicesWakeupCreate
   * @request POST:/accounts/{accountId}/devices/wakeup
   */
  devicesWakeupCreate = (accountId: string, data: PTTWakeUpRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/accounts/${accountId}/devices/wakeup`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name PushnotificationdevicesUpdate
   * @request PUT:/accounts/{accountId}/pushnotificationdevices
   */
  pushnotificationdevicesUpdate = (
    accountId: string,
    data: UpdatePushNotificationRequest,
    params: RequestParams = {},
  ) =>
    this.request<void, any>({
      path: `/accounts/${accountId}/pushnotificationdevices`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
